/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetUserPermission";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteResetUserPermission } from "../axios/usersAuthzAPIAdminPermissionsWriteResetUserPermission";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationKey = () => ["users-authz-api", { url: '/admin/user/:userId/permissions/:permission/reset' }] as const

export type UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationKey>

/**
 * @summary Reset a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/reset}
 */
export function useUsersAuthzAPIAdminPermissionsWriteResetUserPermission<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["permission"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["permission"]}, TContext>({
    mutationFn: async({ userId, permission }) => {
      return usersAuthzAPIAdminPermissionsWriteResetUserPermission(userId, permission, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}